import { isEmbedMode } from 'v2/shared/utils/embed-session'
import { FlowTypes } from 'v2/types'
import { useFlowStore } from '../store'
import { useAiCall } from './use-ai-call'
import { useHasSmsNode, useHasWhatsappNode } from './use-has-messaging-node'
import { useHasVoiceNode } from './use-has-voice-node'

/**
 * Hook to determine visibility of agent settings sections
 * Consolidates logic for showing settings tab and its subsections
 */
export const useAgentSettingsVisibility = () => {
  const currentFlowType = useFlowStore((state) => state.currentFlowType)
  const hasVoiceNode = useHasVoiceNode()
  const hasSmsNode = useHasSmsNode()
  const hasWhatsappNode = useHasWhatsappNode()
  const hasAiCall = useAiCall()
  const showOperatingHours = currentFlowType === FlowTypes.api_request
  const showSettingsTab = true
  // Voice config and event callbacks are not on hodor's embed allow-list yet.
  const isStageOneEmbed = isEmbedMode()
  const showVoiceConfigTab = hasAiCall && !isStageOneEmbed
  const showEventCallbacksTab = (hasVoiceNode || hasSmsNode || hasWhatsappNode) && !isStageOneEmbed
  // Metrics tab (custom judges, replacing Conversation Goal) renders for every
  // flow — a literal, like showSettingsTab.
  const showMetricsTab = !isStageOneEmbed

  return {
    showSettingsTab,
    showMetricsTab,
    showVoiceSetting: hasVoiceNode,
    showOperatingHours,
    showVoiceConfigTab,
    showEventCallbacksTab,
    hasSmsNode,
    hasWhatsappNode,
  }
}
